// Font size: ordered steps for stepper UI
export const FONT_SIZE_STEPS = ['SM', 'MD', 'LG'];

export const FONT_SIZE_MAP = {
  SM: '12px',
  MD: '14px',
  LG: '18px'
};

export const FONT_SIZE_DISPLAY = {
  SM: 12,
  MD: 14,
  LG: 18
};

/**
 * Resolve a fontSize config value to a CSS pixel string.
 */
export function getFontSizeCSS(value) {
  return FONT_SIZE_MAP[value] || FONT_SIZE_MAP.MD;
}

// Background color palette
export const BACKGROUND_COLOR_OPTIONS = [
  { label: 'Transparent', value: 'transparent', color: 'transparent' },
  { label: 'White', value: 'white', color: '#ffffff' },
  { label: 'Gray', value: 'gray', color: '#f5f5f5' },
  { label: 'Blue', value: 'blue', color: '#d4e5ff' },
  { label: 'Green', value: 'green', color: '#d5f0e1' },
  { label: 'Yellow', value: 'yellow', color: '#fff8d4' },
  { label: 'Orange', value: 'orange', color: '#ffe6cc' },
  { label: 'Pink', value: 'pink', color: '#fde0e7' },
  { label: 'Purple', value: 'purple', color: '#e8dcf5' },
  { label: 'Vivid Blue', value: 'vivid_blue', color: '#84b3ff' },
  { label: 'Vivid Green', value: 'vivid_green', color: '#6cd68b' },
  { label: 'Vivid Yellow', value: 'vivid_yellow', color: '#ffdd55' },
  { label: 'Vivid Orange', value: 'vivid_orange', color: '#ffb366' },
  { label: 'Vivid Pink', value: 'vivid_pink', color: '#f790af' },
  { label: 'Vivid Purple', value: 'vivid_purple', color: '#c59eee' }
];

// Horizontal alignment options
export const TEXT_ALIGN_OPTIONS = [
  { label: 'Left', value: 'left', icon: 'FiAlignLeft' },
  { label: 'Center', value: 'center', icon: 'FiAlignCenter' },
  { label: 'Right', value: 'right', icon: 'FiAlignRight' }
];

// Vertical alignment options
export const VERTICAL_ALIGN_OPTIONS = [
  { label: 'Top', value: 'top', icon: 'FiArrowUp' },
  { label: 'Center', value: 'center', icon: 'FiMinus' },
  { label: 'Bottom', value: 'bottom', icon: 'FiArrowDown' }
];

/**
 * Resolve a background color value name to its CSS color.
 */
export function getBackgroundColorCSS(value) {
  const found = BACKGROUND_COLOR_OPTIONS.find((opt) => opt.value === value);
  return found ? found.color : 'transparent';
}
